import jwtDecode from 'jwt-decode'

// this should be an api call but for now we just hard code
const PAGE_PERMISSIONS = {
  '/login': [
    1,
    2,
    3,
    4,
    6,
    5
  ],
  '/admin': [
    1,
    2,
    3,
    6
  ],
  '/configuration': [
    1,
    2,
    3,
    6
  ],
  '/users': [
    1,
    2
  ],
  '/storage': [
    1,
    2
  ],
  '/locations': [
    1,
    2,
    3,
    4,
    6
  ],
  '/contacts': [
    1,
    2
  ],
  '/insurance': [
    1,
    2,
    3,
    4,
    6,
    5
  ],
  '/dashboard': [
    1,
    2,
    3,
    4,
    6
  ],
  '/adas': [
    1,
    2,
    3,
    4,
    6,
    5
  ]
}

export default {
  token: state => state.token,
  passthrough: state => state.passthrough,
  user: state => state.token ? jwtDecode(state.token) : {},
  isAllowed: (state) => {
    return (page = '') => {
      if (!PAGE_PERMISSIONS[page]) { return true }
      if (state.profile.roles && state.profile.roles.length) {
        return state.profile.roles.some(r => PAGE_PERMISSIONS[page].includes(r))
      }
      return PAGE_PERMISSIONS[page].includes('Guest')
    }
  },
  profile: state => state.profile
}



// WEBPACK FOOTER //
// ./src/store/modules/auth/getters.js